'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import MUIButton from '@mui/material/Button'
import { useUrlStore } from '@repo/store/useUrlStore'
import { OspreyIllustration } from '@repo/ui/OspreyIllustration'

export const RedirectToOsprey1Module = ({ url }) => {
  const { queryParams } = useUrlStore()

  const handleClick = () => {
    let redirectUrl = url

    if (queryParams) {
      const queryParamKeys = Object.keys(queryParams)

      if (queryParamKeys.length) {
        const queryParamArray = []

        queryParamKeys.forEach((key) => {
          queryParamArray.push(`${key}=${queryParams[key]}`)
        })

        if (redirectUrl.includes('?')) {
          redirectUrl += '&'
        } else {
          redirectUrl += '?'
        }

        redirectUrl += `${queryParamArray.join('&')}`
      }
    }

    if (redirectUrl) window.open(redirectUrl, '_blank')
  }

  return (
    <MUIStack
      direction="row"
      gap={10}
      alignItems="center"
      sx={{ borderRadius: 2, backgroundColor: 'white', padding: '50px', maxWidth: '800px', margin: '40px auto' }}
      data-testid="RedirectToOsprey1Module"
    >
      <OspreyIllustration />

      <MUIStack direction="column" alignItems={'flex-start'} sx={{ maxWidth: '400px' }}>
        <MUITypography variant="h3">{`Incompatible page`}</MUITypography>

        <MUITypography variant="body1" sx={{ mb: 4 }}>
          {`We're sorry, but this page cannot be opened in the current version of Osprey. We're working on a solution!`}
        </MUITypography>

        <MUITypography variant="body1">
          {`In the meantime, please click the button below to
        open the legacy version of this page in a new tab.`}
        </MUITypography>
        <MUIButton size="large" variant="contained" sx={{ mt: 8 }} onClick={handleClick}>
          Open in new tab
        </MUIButton>
      </MUIStack>
    </MUIStack>
  )
}

RedirectToOsprey1Module.propTypes = {
  url: PropTypes.string
}
